export default {
  functionKey: "TRIM",
  title: "TRIM",
  group: "Texte",
  origin: [],
  target: [],
  description: "Supprime les espaces en début et fin de texte",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.trim();`;
    return { displayCode: code, safeCode: code };
  }
}
